import React from 'react';
import SEO from '../components/SEO';
import ConferenceHero from '../components/ConferenceHero';
import ConferenceOverview from '../components/ConferenceOverview';
import HallGallery from '../components/HallGallery';
import OtherServices from '../components/OtherServices';
import ConferenceTable from '../components/ConferenceTable';


const ConferenceHall = ({ language }) => {
  return (
    <>
      <SEO
        title="Conference Hall"
        description="Professional conference facilities at Blue Nest Hotel. Perfect venue for meetings, events, and business gatherings."
        url="/conference"
      />
      <ConferenceHero language={language} />
      <ConferenceOverview language={language} />
      <ConferenceTable language={language} />
      <HallGallery language={language} />
      <OtherServices language={language} />
    </>
  );
};

export default ConferenceHall;
